const extractBuildInfo = () => {
  console.log('process.env.ADAMoracle_VERSION::', process.env)
  const matches =
    /(\d+\.\d+\.\d+)@(.+)$/g.exec(process.env.ADAMoracle_VERSION) || []
  return {
    version: matches[1] || 'unknown',
    sha: matches[2] || 'unknown',
  }
}

export default extractBuildInfo